<div [class]="primaryCard ? 'new-card primary cli-card ocdClick' : 'new-card primary cli-card' " (click)="primaryCard ? createJourneyForCli() : null ">
  <div class="cli-info-wrapper">
    <div class="cli-icon"
      [style.background-image]="'url(' + s3Url + '/cjm/cl-increase/money_bag.png)'">
    </div>
    <div class="info-section">
      <div class="header-section">
        <h2 class="status-header" [textContent]="primaryCard ? 'Verify your income to increase your credit limit' : 'Need more?'"></h2>
        <div class="header-icon" *ngIf="!primaryCard"
          [style.background-image]="'url(' + s3Url + '/cjm/cl-increase/star_eyes.png)'">
        </div>
      </div>
      <div *ngIf="!primaryCard">Verify your income to increase your credit limit</div>
      <button id="continue" class="btn zest-btn cli" (click)="createJourneyForCli()"
        >Increase Credit Limit</button>
    </div>
  </div>
</div>